<template>
  <div>
    <form @onsubmit.prevent action>
      <div class="row mb5">
        <div class="col-md-4"></div>
        <div class="col-md-3 text-center">
          <label class="form-control-label text-bold" v-if="pType=='p1'">S</label>
          <label class="form-control-label text-bold" v-else>Benchmark</label>
        </div>
        <div class="col-md-2 text-center" v-if="pType!=='s1'">
          <label class="form-control-label text-bold">Weight</label>
        </div>
      </div>
      <div
        v-for="(field, index) in fields"
        v-bind:key="index"
        class="row"
        style="margin-bottom: 10px;"
      >
      
        <div class="col-md-4">
          <!-- <br v-if="field.reletedField.length==0"> -->
          <label :for="field.name" class="form-control-label">{{getLabel(field.label)}}  </label>
        </div>
        <div class="col col-md-3" v-if="field.reletedField.length>0">
          <input
            :type="field.type"
            v-model="formData[field.name+'_s']"
            :id="field.name"
            placeholder="Enter S"
            class="form-control"
            v-if="pType=='p1'"
          >
          <input
            :type="field.type"
            v-model="formData[field.name+'_benchmark']"
            :id="field.name"
            placeholder="Enter S"
            class="form-control"
            v-else
          >
          <!-- <small v-if="errors[field.name].source" class="form-text text-danger">{{errors[field.name].source}}</small> -->
        </div>
        <div class="col col-md-2" v-if="field.reletedField.length>0 && pType!=='s1'">
          <input
            :type="field.type"
            v-model="formData[field.name+'_weight']"
            :id="field.name"
            placeholder="Enter Weight"
            class="form-control"
          >
          <!-- <small v-if="errors[field.name].Date" class="form-text text-danger">{{errors[field.name].Date}}</small> -->
        </div>
        <div class="col col-md-3" v-if="field.reletedField.length==0 && pType!=='s1'">
          <!-- <label class="control-label">Value</label><br/> -->
          <input
            :type="field.type"
            v-model="formData[field.name]"
            :id="field.name"
            placeholder="Enter Weight"
            class="form-control"
          >
          <!-- <small v-if="errors[field.name].Date" class="form-text text-danger">{{errors[field.name].Date}}</small> -->
        </div>
      </div>
      <div class="form-group pull-right">
        <!-- <submitButton @click.prevent="submit" type="submit" class="btn btn-info">Submit</submitButton> -->
        <button @click="save" type="button" class="btn btn-primary">Save</button>
        <button @click="updatedata" type="button" class="btn btn-primary">Save & Update</button>
      </div>
      <PinCheck
        :show.sync="show"
        ref="smallModal"
        v-bind:small="true"
        @submitForm="submitForm"
        :cancelClass="'btn btn-secondary'"
      ></PinCheck>
    </form>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import { formCommonMixins } from "../../assets/mixins/formcommon.js";
import PinCheck from "@/components/PinCheck.vue";
export default {
  components: { PinCheck },
  mixins: [commonMixins, formCommonMixins],
  props: ["globaldata", "pType"],
  created() {
    console.log('form type', this.pType);
  },
  data() {
    return {
      show: false,
      curDate: new Date(),
      fields: [],
      formData: {},
      errors: [],
      defaultSrc: "",
      data: []
    };
  },
  methods: {
    cancel(d) {
      console.log("Cancel =>", d);
    },
    submitForm() {
      console.log("submitpin entered");
      // this.validatePin(pin);
      if (this.pType === "p1") this.submitP1();
      else if(this.pType === "s1") this.submitS1();
      else this.submitPBenchmarkAndWeight();
    },
    showSmallModal() {
      this.$refs.smallModal.open();
    },
    save(){
      this.globaldata['update'] = 0;
      this.$refs.smallModal.open();
    },
    updatedata(){
      console.log("UPdate");
      this.globaldata['update'] = 1;
      this.$refs.smallModal.open();
    }
  },
  watch: {
    globaldata: function(value) {
      console.log("Global data change", value);
      this.data = value;
      for (var i in value) {
        this[i] = value[i];
      }
      this.setCommonData();
      this.setFormData();
    }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
</style>



// WEBPACK FOOTER //
// src/views/manual-forms/p-form.vue